export const ProductType = {
  SkiPass: 0,
  Ticket: 1,
} as const

export type ProductType = (typeof ProductType)[keyof typeof ProductType]
